// src/pages/Disclaimer.tsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Disclaimer() {
  const navigate = useNavigate();
  const { t } = useTranslation('legal');

  // Enable scrolling for this standalone page (not wrapped in BaseLayout)
  useEffect(() => {
    document.documentElement.classList.add('allow-scroll');
    document.body.classList.add('allow-scroll');
    document.getElementById('root')?.classList.add('allow-scroll');
    return () => {
      document.documentElement.classList.remove('allow-scroll');
      document.body.classList.remove('allow-scroll');
      document.getElementById('root')?.classList.remove('allow-scroll');
    };
  }, []);

  return (
    <div className="relative min-h-screen flex items-center justify-center px-4 py-16 text-white">
      <div className="w-full max-w-3xl bg-black/60 backdrop-blur-md p-8 rounded-lg">
        <h1 className="text-3xl font-bold mb-6 text-yellow-400">{t('disclaimer.title')}</h1>

        <p className="mb-4">
          <strong>ViewsBoost</strong> {t('disclaimer.content.intro')}
        </p>

        <p className="mb-4">
          {t('disclaimer.content.noAffiliation')}
        </p>

        <p className="mb-4">
          {t('disclaimer.content.iframeApi')}
        </p>

        <p className="mb-4">
          {t('disclaimer.content.rewardSystem')}
        </p>

        <p className="mb-4">
          {t('disclaimer.content.userResponsibility')}
        </p>

        <p className="mb-4">
          {t('disclaimer.content.apiUsage')}{' '}
          <a
            href="https://developers.google.com/youtube/terms/api-services-terms-of-service"
            className="text-yellow-400 underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('disclaimer.content.youtubeApiTerms')}
          </a>{' '}
          {t('disclaimer.content.and')}{' '}
          <a
            href="https://policies.google.com/privacy"
            className="text-yellow-400 underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('disclaimer.content.googlePrivacyPolicy')}
          </a>
          .
        </p>

        <p className="mt-6">{t('disclaimer.content.contact')}</p>

        <button
          onClick={() => navigate(-1)}
          className="mt-8 bg-gradient-to-r from-yellow-400 to-orange-500 text-[#0a0a0a] font-semibold px-6 py-3 rounded-lg shadow-lg hover:scale-105 transition"
        >
          {t('disclaimer.goBack')}
        </button>
      </div>
    </div>
  );
}
